import { HttpClient } from '@angular/common/http';

import { Observable, ReplaySubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { AnywhereData, AnywhereResponse } from './types/anywhere-api.type';
import { AnywhereFilters, AnywhereQueryParams } from './types/anywhere.type';
import { CloudMatrixUtils } from './utils/cloud-matrix-utils';
import { CloudMatrixModule } from './cloud-matrix.module';

@Injectable({
  providedIn: CloudMatrixModule,
})
export class CloudMatrixService<AnywhereMetaData> {
  /**
   * Cache any VOD list based on the url and parameters
   */
  private cache: { [url: string]: ReplaySubject<AnywhereData<AnywhereMetaData>> };

  constructor(
      protected httpClient: HttpClient,
  ) {
    this.cache = {};
  }

  /**
   * Method to get the list of VOD, return an Observable<AnywhereData<AnywhereMetaData>>
   */
  triggerApiCall(
      apiUrl: string,
      pageSize: number,
      anywhereData?: AnywhereData<AnywhereMetaData>,
      filters?: AnywhereFilters,
      noCache?: boolean,
      queryParams?: AnywhereQueryParams,
      startPageIndex?: number,
  ): Observable<AnywhereData<AnywhereMetaData>> {
    let noMoreData = false;
    let urlParameters: AnywhereQueryParams;
    let anywhereUrl = '';


    queryParams = {...queryParams, day: new Date().getDate().toString()}; // refresh cache once per day


    if (anywhereData && anywhereData.pagingData) {
      // load next page
      if (CloudMatrixUtils.isMoreDataAvailable(anywhereData.pagingData)) {
        urlParameters = {...queryParams, ...CloudMatrixUtils.generateAnywhereSearchQuery(filters)};

        anywhereUrl = CloudMatrixUtils.generateAnywhereUrl(apiUrl,
            urlParameters,
            pageSize,
            anywhereData.pagingData.pageIndex + 1);

      } else {
        noMoreData = true;
      }
    } else {
      urlParameters = {...queryParams, ...CloudMatrixUtils.generateAnywhereSearchQuery(filters)};
      // load first page
      anywhereUrl = CloudMatrixUtils.generateAnywhereUrl(apiUrl,
          urlParameters,
          pageSize,
          startPageIndex || 0);
    }

    const cacheKey = anywhereUrl;

    if (noCache || !this.cache[cacheKey]) {
      if (noMoreData && this.cache[cacheKey]) {
        this.cache[cacheKey].next(anywhereData);
      } else {
        this.cache[cacheKey] = new ReplaySubject(1);

        this.httpClient.get<AnywhereResponse<AnywhereMetaData>>(anywhereUrl)
            .subscribe(data => {
              if (data) {
                anywhereData = CloudMatrixUtils.getItemData<AnywhereMetaData>(anywhereData, data);
                anywhereData.urlParameters = urlParameters;
                this.cache[cacheKey].next(anywhereData);
              } else {
                this.cache[cacheKey].next({itemData: []});
              }
            }, error => {
              this.cache[cacheKey].next({
                error: true,
              });
            });
      }
    }

    return this.cache[cacheKey].asObservable();
  }
}
